export const reportTypes = {
    "ito": {
        displayName: "Industry Trends and Opportunities",
        folder: "industry_trends_and_opportunities",
        fileName: "Industry_Trends_and_Opportunities_Report.pdf"
    },
    "sra": {
        displayName: "Scaleup Readiness Assessment and Action Plan",
        folder: "assessment_and_action_plan",
        fileName: "Scaleup_Readiness_Assessment_and_Action_Plan.pdf"
    },
    "sgp": {
        displayName: "Scaleup Growth Plan",
        folder: "scaleup_growth_plan",
        uploadsDirectory: "growth_plans_docs",
        fileName: "Scaleup_Growth_Plan.pdf"
    }
}